module.exports = __webpack_public_path__ + "static/media/icon-arrow-orange-up.574257a6.svg";